import { render, staticRenderFns } from "./ObiCheckbox.vue?vue&type=template&id=bd39eb8a&scoped=true&"
import script from "./ObiCheckbox.vue?vue&type=script&lang=js&"
export * from "./ObiCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd39eb8a",
  null
  
)

export default component.exports